<template>
    <div class="cc-attribute-selectors">
        <attribute-selector v-for="group in attributes" v-bind:key="group.id" :group="group" @selectAttribute="selectAttribute"/>
    </div>
</template>

<script>
    import {mapState} from 'vuex';

    import AttributeSelector from "./AttributeSelector";

    export default {
        components: {
            AttributeSelector,
        },
        computed: {
            ...mapState({
                translations: state => state.translations,
            }),
        },
        methods: {
            selectAttribute: function (attribute) {
                this.$emit('selectAttribute', attribute);
            },
        },
        props: [
            'attributes',
        ],
    };
</script>

<style lang="scss" scoped="scoped">
    @import "./scss/components/attribute-selectors";
</style>
